import { render, staticRenderFns } from "./Redirection.vue?vue&type=template&id=8848ea2a&scoped=true"
import script from "./Redirection.vue?vue&type=script&lang=js"
export * from "./Redirection.vue?vue&type=script&lang=js"
import style0 from "./Redirection.vue?vue&type=style&index=0&id=8848ea2a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8848ea2a",
  null
  
)

export default component.exports